import React from "react";
import { useForm } from "react-hook-form";
import { CustomerView } from "@tiny/api";

import {
  useGetCustomerTagsQuery,
  usePutCustomerByCustomerIdMutation,
} from "@tiny/api";
import { EditSubscriberDialogProps } from "./EditSubscriberDialog";

export function useEditSubscriberDialog(props: EditSubscriberDialogProps) {
  const { open, onSuccess, customer } = props;

  const form = useForm();

  const { data: { tags: customerTags = [] } = {} } = useGetCustomerTagsQuery({
    enabled: open,
    staleTime: 0,
    select(data) {
      return {
        ...data,
        tags: data.tags?.sort(Intl.Collator().compare),
      };
    },
  });

  const { mutateAsync: putCustomerByCustomerMutateAsync, isLoading: saving } =
    usePutCustomerByCustomerIdMutation();

  const submitForm = React.useCallback(
    async (values: CustomerView) => {
      if (customer?.id) {
        await putCustomerByCustomerMutateAsync({
          customerId: customer?.id,
          data: values,
        });
        onSuccess();
      }
    },
    [customer?.id, onSuccess, putCustomerByCustomerMutateAsync]
  );

  const save = React.useCallback(async () => {
    form.handleSubmit(submitForm)();
  }, [form, submitForm]);

  React.useEffect(() => {
    if (open) {
      form.reset(customer);
    } else {
      form.reset({});
    }
  }, [customer, form, open]);

  return {
    form,
    submitForm,
    save,
    saving,
    customerTags,
  };
}
